import { Alert } from '@all-manager/design-system-v2';

type Props = {
  error: string | null;
}

export default function ServerErrorAlert(props: Props) {
  if (!props.error) {
    return null;
  }

  return (
    <Alert severity="error">{props.error}</Alert>
  );
}
